import { UserSettings } from '../models/UserSettings';

export class PutUserSettingsRequest {

  userSettings?: UserSettings;

  constructor(init?: Partial<PutUserSettingsRequest>) {
    Object.assign(this, init);
  }
}
